import React, { useState } from 'react';
import bem from 'utils/bem';
import CountrySelectWithIconAndDefaultCountry from './CountrySelect';
import ru from 'react-phone-number-input/locale/ru.json';
import 'react-phone-number-input/style.css';
import PhoneInput, { formatPhoneNumberIntl, getCountryCallingCode } from 'react-phone-number-input';
import { getExampleNumber } from 'libphonenumber-js/min';
import examples from 'libphonenumber-js/examples.mobile.json';

import './index.sass';

const { cnBlock, el } = bem('form-field', 'form-phone');

const defaultCountry = 'RU';
const CountrySelect = CountrySelectWithIconAndDefaultCountry(defaultCountry);

const PhoneField = ({ className, name, value, onChange, error, disabled = false, loading, placeholder, ...rest }) => {

    const [ country, setCountry ] = useState(defaultCountry);

    const getPlaceholderForCountry = (country) => {
        const exampleNumber = getExampleNumber(country, examples)?.number;
        const formattedExampleNumber = formatPhoneNumberIntl(exampleNumber);
        const callingCode = `+${ getCountryCallingCode(country) }`;
        return formattedExampleNumber.replace(`${ callingCode } `, '');
    };

    return (
        <div className={ el('container') }>
            <PhoneInput
                name={ name }
                className={ cnBlock(className, { 'invalid': error}) }
                disabled={ disabled }
                defaultCountry={ defaultCountry }
                labels={ ru }
                value={ value }
                onChange={ onChange }
                placeholder={ placeholder || getPlaceholderForCountry(country) }
                countrySelectComponent={ CountrySelect }
                onCountryChange={ (country) => {
                    if (country) {
                        setCountry(country);
                    }
                } }
                { ...rest }
            />
            { error && <div className="form-error">{ error }</div> }
        </div>
    );
};

export default PhoneField;
